import "./WorkCardsStyles.css"
import React from 'react'
import Slideshow from "./Slides"
import SlideshowMultiPg from "./MultiPageSlides"

const WorkCards = () => {
    
  return (
    <div className="PageArea">
    <div className="work-container">

    <Slideshow type='singlePage'/>
    <SlideshowMultiPg type='multiplePages'/>
    
    </div></div>
  )
}

export default WorkCards